import { HourlyRequestFilteredReferentialsIds } from '@scenario/models/hourly-request-filtered-referentials-ids.model';
import { HourlyRequestFilteredReferentialsGateway } from '@scenario/gateways/hourly-request-filtered-referentials.gateway';
import { environment } from '../../../../../environments/environment';
import { formatPostHeaders } from '@configurations/api-configuration';

export class ApiHourlyRequestFilteredReferentialsGateway implements HourlyRequestFilteredReferentialsGateway {
  private readonly hourlyRequestFilteredReferentialsApi = `${environment.backend_url}/api/v1/hourlyRequestDynamicFilter`;

  async retrieveAllIds(filters: HourlyRequestFilteredReferentialsIds): Promise<HourlyRequestFilteredReferentialsIds> {
    try {
      const response = await fetch(`${this.hourlyRequestFilteredReferentialsApi}`, await formatPostHeaders(filters));
      return await response.json();
    } catch (error) {
      throw new Error('Error retrieving hourly request filtered referentials :' + error);
    }
  }
}
